export default __webpack_public_path__ + "static/media/content.49b2431e.mp4";